import React from 'react';
import { Router, Route } from 'react-router-dom';
import App from './app';
import History from '../../util/history';
// import withTracker from './tracker';
export default class Intl extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Router history={History}>
                <Route path="/" component={App} />
            </Router>
        );
    }
}